import React from 'react'

import DynamicPresentationCard from '../../../../containers/dynamic/DynamicPresentationCard'
import EditableReply from '../../../../containers/replies/EditableReply'

const Reply = ({ item, disabled }) => {
  return (
    <DynamicPresentationCard
      reply={item}
      noWrapper
      size="small"
      ValueWrapper={props => <EditableReply record={item} {...props} disabled={disabled} />}
    />
  )
}

export default Reply
